import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/context/SiteContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import RendezVous from "@/pages/RendezVous";
import Contact from "@/pages/Contact";
import Planning from "@/pages/Planning";
import Simulation from "@/pages/Simulation";
import MonRendezVous from "@/pages/MonRendezVous";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const Page = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Page><Home /></Page>} />
          <Route path="/simulation" element={<Page><Simulation /></Page>} />
          <Route path="/planning" element={<Page><Planning /></Page>} />
          <Route path="/rendez-vous" element={<Page><RendezVous /></Page>} />
          <Route path="/contact" element={<Page><Contact /></Page>} />
          <Route path="/mon-rendez-vous" element={<Page><MonRendezVous /></Page>} />
          <Route path="/mentions-legales" element={<Page><Legal kind="mentions" /></Page>} />
          <Route path="/confidentialite" element={<Page><Legal kind="privacy" /></Page>} />
          <Route path="/cgv" element={<Page><Legal kind="cgv" /></Page>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
